import { render, staticRenderFns } from "./ListPrivateCategoryView.vue?vue&type=template&id=53431684"
import script from "./ListPrivateCategoryView.vue?vue&type=script&lang=ts"
export * from "./ListPrivateCategoryView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports